import _ from 'lodash';

import { ChecklistItemDeterminationType } from 'constants/checklists';
import { ChecklistOverrideType } from 'constants/loanApplication';

export const getActionParams = ({ item }) => {
  switch (item.expressionResult) {
    case ChecklistItemDeterminationType.TRUE:
    case ChecklistItemDeterminationType.FALSE:
      return item.calculation.wasOverriden
        ? {
            buttonText: 'Remove Override',
            buttonVariant: 'outlined',
            isRemoveOverride: true,
          }
        : {
            buttonText: 'Override',
            buttonVariant: 'outlined',
          };

    case ChecklistItemDeterminationType.MANUAL:
      return item.calculation.wasOverriden
        ? {
            buttonText: 'Reset',
            buttonVariant: 'outlined',
            isRemoveOverride: true,
          }
        : {
            buttonText: 'Complete',
          };

    case ChecklistItemDeterminationType.NEEDS_REVIEW:
      return item.calculation.wasOverriden
        ? {
            buttonText: 'Reset',
            buttonVariant: 'outlined',
            isRemoveOverride: true,
          }
        : {
            buttonText: 'Mark Reviewed',
          };

    default:
      return {};
  }
};

export const getCalc = ({ differenceWithRootCategory, columnPercentWidth }) => {
  return `calc((100% + ${differenceWithRootCategory}px) * ${columnPercentWidth})`;
};

export const getActionBody = ({ itemId, isRemoveOverride }) => {
  return {
    itemsToOverride: isRemoveOverride ? [] : [itemId],
    itemsToRemoveOverride: isRemoveOverride ? [itemId] : [],
  };
};

export const normalizeCalculationsPendingChange = ({ item }) => {
  const { calculation } = item;
  const calculationsPendingChange = _.get(item, 'calculation.pendingChangeStatus.change');
  const isItemPendingOverride = calculationsPendingChange?.type === ChecklistOverrideType.OVERRIDE;

  return {
    ...item,
    calculation: calculationsPendingChange
      ? {
          ...item.calculation,
          overrideDate: calculationsPendingChange?.createdDate,
          overridenBy: calculationsPendingChange?.byUserId,
          // FH-3004: the pending change's own resolved name, not the (possibly stale) committed
          // override's — flag-OFF items carry neither field, so this stays undefined there.
          overridenByName: item.calculation.pendingChangeByName,
          pendingResult: isItemPendingOverride,
          wasOverriden: isItemPendingOverride,
        }
      : calculation,
  };
};
